export default "__VITE_ASSET__83d21814__"